export default __webpack_public_path__ + "static/media/il-regional-road.02c0f6e1.svg";